import { Shuffle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const label = (c, a) => [c, a].filter(Boolean).join(" · ");

export const CategoryChangeDialog = ({ perf, open, onClose }) => (
  <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="bg-[#1C2541] border-amber-500/50" data-testid="category-change-dialog">
      <DialogHeader><DialogTitle className="font-display text-2xl uppercase text-amber-300 flex items-center gap-2"><Shuffle className="w-6 h-6" />Zmiana kategorii</DialogTitle></DialogHeader>
      <div className="grid gap-3 text-sm">
        <div className="rounded-xl bg-[#0B132B]/70 p-3">
          <div className="text-xs uppercase tracking-wider text-slate-500">Poprzednio</div>
          <div className="text-slate-300 font-semibold" data-testid="category-change-from">{label(perf.category_change?.from_category, perf.category_change?.from_age_group)}</div>
        </div>
        <div className="rounded-xl bg-amber-500/10 border border-amber-500/40 p-3">
          <div className="text-xs uppercase tracking-wider text-amber-300">Teraz oceniasz</div>
          <div className="text-lg font-bold" data-testid="category-change-to">{label(perf.category, perf.age_group)}</div>
        </div>
        <button data-testid="category-change-ok" onClick={onClose} className="h-12 rounded-xl bg-amber-600 hover:bg-amber-500 font-semibold">OK, rozumiem</button>
      </div>
    </DialogContent>
  </Dialog>
);
